/* Rova: add Refunds and Terms next to Privacy in the bottom row of the custom footer (assets/rova-footer.js builds the footer) */
(function () {
  var LINKS = [
    ["/policies/refund-policy", "Refunds"],
    ["/policies/terms-of-service", "Terms"]
  ];
  function addLinks() {
    var rows = document.querySelectorAll("#rova-footer .rf-small");
    rows.forEach(function (row) {
      if (row.getAttribute("data-rova-pol")) return;
      var privacy = row.querySelector('a[href*="privacy"]');
      if (!privacy) return;
      row.setAttribute("data-rova-pol", "1");
      var after = privacy;
      LINKS.forEach(function (l) {
        var a = document.createElement("a");
        a.href = l[0];
        a.textContent = l[1];
        after.insertAdjacentElement("afterend", a);
        after = a;
      });
    });
  }
  var tick = false;
  function schedule() {
    if (tick) return;
    tick = true;
    setTimeout(function () { tick = false; addLinks(); }, 50);
  }
  function start() {
    addLinks();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
